import type { ResponseType } from '@/types/common';
import type { IssueTemplate, IssueTemplateFieldConfig } from '@/types/issue';
import httpUtil from '@/utils/http';
export * from './project';

const request = httpUtil.accurate.request;
const prefix = 'v1/issues';

export const issueTemplateApi = {
  /**
   * @description 根据 issue id 获取问题对应的模板
   */
  getByIssueId(id: number): ResponseType {
    return request({
      url: prefix + '/' + id + '/template',
      method: 'GET',
    });
  },

  /**
   * @description 根据 issueKey 获取问题对应的模板
   */
  getByIssueKey(issueKey: string): ResponseType {
    return request({
      url: prefix + '/key/' + issueKey + '/template',
      method: 'GET',
    });
  },

  /**
   * @description 获取所有模板
   */
  getAll(): ResponseType<IssueTemplate[]> {
    return request({
      url: prefix + '/templates',
      method: 'GET',
    });
  },

  /**
   * @description 更新模板
   */
  create(data: any): ResponseType {
    return request({
      url: prefix + '/template',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新模板
   */
  update(id: number, data: any): ResponseType {
    return request({
      url: prefix + '/template/' + id,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除模板
   */
  del(id: number): ResponseType {
    return request({
      url: prefix + '/template/' + id,
      method: 'DELETE',
    });
  },

  /**
   * @description 获取模板
   */
  get(templateId: number): ResponseType<IssueTemplateFieldConfig[]> {
    return request({
      url: prefix + `/template/${templateId}/fields`,
      method: 'GET',
    });
  },

  /**
   * @description 创建模板字段配置
   */
  postConfig(
    templateId: number,
    data: {
      fieldId: number;
      fieldName: string;
      description?: string;
      isRequired: boolean;
      isShow: boolean;
    },
  ): ResponseType {
    return request({
      url: prefix + `/template/${templateId}/config`,
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新模板字段配置
   */
  updateConfig(
    templateId: number,
    configId: number,
    data: { description?: string; isRequired: boolean; isShow: boolean },
  ): ResponseType {
    return request({
      url: prefix + `/template/${templateId}/config/${configId}`,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除模板字段配置
   */
  delConfig(templateId: number, configId: number): ResponseType {
    return request({
      url: prefix + `/template/${templateId}/config/${configId}`,
      method: 'DELETE',
    });
  },

  /**
   * @description 移动模板字段配置
   */
  moveConfig(templateId: number, data: { moveId: number; targetId: number; isBottom: boolean }): ResponseType {
    return request({
      url: prefix + `/template/${templateId}/config/move`,
      method: 'POST',
      data,
    });
  },
};
